var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading-spinner"},[_vm._v(" Lädt... "),_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('div',[_c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.chartData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }